import { render, staticRenderFns } from "./ExternalOrderOrder.component.vue?vue&type=template&id=19488f35&scoped=true&"
import script from "./ExternalOrderOrder.component.vue?vue&type=script&lang=js&"
export * from "./ExternalOrderOrder.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19488f35",
  null
  
)

export default component.exports